module.exports = __webpack_public_path__ + "img/d1.eca83c52.png";